export default "<!-- This page is intentionally left blank -->\n<!-- Keep this file empty so that i18n will use base values for english -->\n";